import { render, staticRenderFns } from "./WasteItem.vue?vue&type=template&id=b254388a&scoped=true&"
import script from "./WasteItem.vue?vue&type=script&lang=js&"
export * from "./WasteItem.vue?vue&type=script&lang=js&"
import style0 from "./WasteItem.vue?vue&type=style&index=0&id=b254388a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b254388a",
  null
  
)

export default component.exports